import { memo, Fragment, useState, useEffect } from "react";
import { useRouter } from "next/router";
import { Navbar, Container } from "react-bootstrap";

// Components
import Logo from "../logo";
import MainNavigation from "./header/MainNavigation";
import SearchBar from "./header/SearchBar";
import UserProfileMenu from "./header/UserProfileMenu";

const HeaderDefault = memo(() => {
  const [isMega, setIsMega] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const location = useRouter();

  // First useEffect to detect client-side rendering
  useEffect(() => {
    setIsClient(true);
  }, []);

  // Handle scroll event for sticky header - only on client
  useEffect(() => {
    // Skip this effect during SSR
    if (!isClient) return;

    const handleScroll = () => {
      const headerSticky = document.querySelector(".header-sticky");
      if (headerSticky) {
        if (window.scrollY > 1) {
          headerSticky.classList.add("sticky");
        } else {
          headerSticky.classList.remove("sticky");
        }
      }
    };

    // Check if we're on the homepage to enable mega menu
    const updateIsMega = () => {
      setIsMega(location.asPath === "/");
    };

    window.addEventListener("scroll", handleScroll);
    updateIsMega();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location, isClient]);

  // Toggle mobile menu
  const handleMobileMenuToggle = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <Fragment>
      <header className="header-center-home header-default header-sticky">
        <Navbar
          expand="xl"
          className="nav navbar-light iq-navbar header-hover-menu py-xl-0"
        >
          <Container fluid className="navbar-inner">
            <div className="d-flex align-items-center justify-content-between w-100 landing-header">
              {/* Left side - Logo and mobile menu toggle */}
              <div className="d-flex gap-3 gap-xl-0 align-items-center">
                <div>
                  <button
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#navbar_main"
                    aria-controls="navbar_main"
                    className="d-xl-none btn btn-primary rounded-pill p-1 pt-0 toggle-rounded-btn"
                    onClick={handleMobileMenuToggle}
                  >
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>
                <Logo />
              </div>

              {/* Main Navigation */}
              <MainNavigation
                isMega={isMega}
                isOpen={showMobileMenu}
                onToggle={handleMobileMenuToggle}
              />

              {/* Right side - Search and User Profile */}
              <div className="right-panel d-flex align-items-center my-2">
                <div className="nav-item nav-icon me-3 row">
                  <SearchBar />
                </div>
                <div className="nav-item nav-icon dropdown">
                  <UserProfileMenu />
                </div>
              </div>
            </div>
          </Container>
        </Navbar>
      </header>
    </Fragment>
  );
});

HeaderDefault.displayName = "HeaderDefault";
export default HeaderDefault;
